import { GooglePlusOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import React, { useContext } from "react";
import { UserContext } from "../../auth/user-context";
import UserButton from "../user-button/user-button";
import "./auth-buttons.scss";

export interface AuthButtonsProps {
  isMobile?: boolean;
  style?: React.CSSProperties;
}

export const AuthButtons: React.FC<AuthButtonsProps> = (props) => {
  const { user, logOut, logIn } = useContext(UserContext);

  return user?.uid ? (
    <Menu
      mode="horizontal"
      className="d-flex justify-content-around bg-primary"
    >
      <Menu.SubMenu key="auth" icon={<UserButton />}>
        <Menu.Item key="7" onClick={logOut}>
          Log-out
        </Menu.Item>
      </Menu.SubMenu>
    </Menu>
  ) : (
    <span className="ant-menu-item" onClick={logIn}>
      <GooglePlusOutlined />
      Login
    </span>
  );
};

export default AuthButtons;
